import { Component, OnInit } from '@angular/core';
import {Entry} from "contentful";
import {ContentfulService} from "../contentful.service";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {

  categories: Entry<any>[];

  constructor(private contentfulService: ContentfulService) { }
  ngOnInit() {
    this.contentfulService.getCategories()
      .then(categories => { this.categories = categories; });
  }
}
